import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import queryString from 'query-string';
import './BeginChallengeDetail.scss';
import { ChallengeDetailSlider, ChallengeButton, commonConstant } from '../../../common';
import { CHALLENGE, CHALLENGE_DETAIL, contentRegEx } from '../../../common/challengeConstants';
import { fetchBeginChallengeDetail } from '../../../actions';
import { decodeHtml, getParamsString, isEmptyObject } from '../../../utill.func';


const BeginChallengeDetail = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  //params
  const params = queryString.parse(location.search);
  const challengeId = params['challengeId'];
  const eventId = params['eventId'];
  const isRegistered = params['isRegistered'];

  //states
  const [titleClass, setTitleClass] = useState('');
  const [decodedContent, setDecodedContent] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  let showButton = isRegistered === 'true';
  const challenge = useSelector(
      (state) => state.challengeListObj?.beginSelectedChallenge.challengeDetails,
    );

  const fetchDetail = async (id) => {
    setIsLoading(true);
    await dispatch(fetchBeginChallengeDetail(id));
    setIsLoading(false);
  };

  const contentHeight =
    window.screen.height <= 730
      ? CHALLENGE_DETAIL.minContentHeightSm
      : CHALLENGE_DETAIL.minContentHeight;

  const handleDrag = (contentHeight) => {
    if (contentHeight === CHALLENGE_DETAIL.maxContentHeight) {
      setTitleClass('begin-challenge-details-title-wrap');
    } else if (contentHeight <= CHALLENGE_DETAIL.minContentHeight) {
      setTitleClass('');
    }
  };

  useEffect(() => {
    if (challenge?.content) {
      setDecodedContent(decodeHtml(challenge.content));
    }
  }, [challenge]);

  useEffect(() => {
    if (!challenge || isEmptyObject(challenge)) {
      fetchDetail(challengeId);
    }
  }, []);

  const handleClick = () => {
    //Redirect to begin team Dashboard page
    const paramsObj = {
      challengeId : challengeId,
      eventId : eventId
    }
    history.push(`${commonConstant.pathBeginChallengeTeamDashBoard}?${getParamsString(paramsObj)}`);
  }

  return (
    <div className="begin-challenge-details">
      <img
        className="begin-challenge-details-image"
        src={challenge.challengeDetailImg}
        alt="begin-challenge-detail-img"
      />

      <ChallengeDetailSlider
        minHeight={contentHeight}
        defaultHeight={contentHeight}
        maxHeight={CHALLENGE_DETAIL.maxContentHeight}
        showGrab={false}
        styleObj={{ bottom: '10vh' }}
        onDrag={handleDrag}
      >
        <div className="begin-challenge-details-content">
          <div
            className={`begin-challenge-details-title ${titleClass}`}
          >
            {challenge.name}
          </div>

          <div className="begin-challenge-details-description">
            {challenge.description}
          </div>

          <div className="begin-challenge-details-seperator"/>

          <div className="begin-challenge-details-info" >
            {contentRegEx.test(decodedContent) ? (
              <div dangerouslySetInnerHTML={{ __html: decodedContent }} />
            ) : (
              <pre>{decodedContent}</pre>
            )}
          </div>
        </div>
      </ChallengeDetailSlider>

      <div className="begin-challenge-details-footer">
        {showButton && (
          <ChallengeButton 
            btnTitle={CHALLENGE.beginTeamDashboard.challengeDetailFooterButton} 
            successBtn={true}
            onBtnClick={() =>
              handleClick()
            }
          />
        )}
      </div>
    </div>
  );
};

export default BeginChallengeDetail;